/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import VueRouter from 'vue-router';
import { Module, createNamespacedHelpers } from 'vuex';

import { Service } from '@/pages/audit_setup_wizard/asw_service';
import { MapGetters, MapActions, fixStoreElement } from '@/utils';

import createActions, { Actions } from './actions';
import createState, { State } from './state';
import getters, { Getters } from './getters';
import mutations from './mutations';

export const { mapGetters, mapActions } = (createNamespacedHelpers('auditSetupWizard') as any) as {
  mapGetters: MapGetters<Getters>;
  mapActions: MapActions<Actions>;
};

export default (service: Service, router: VueRouter): Module<State, any> => ({
  namespaced: true,
  state: createState(),
  getters: fixStoreElement(getters),
  actions: fixStoreElement(createActions(service, router)),
  mutations: fixStoreElement(mutations),
});
